import request from "@/utils/request";

// 获取区域列表
export function selectZoneInfos(taskId) {
  let id = "";
  if (taskId) {
    id = `?taskId=${taskId}`;
  }
  return request({
    url: `/test/testRealTimeMonitor/selectZoneInfos${id}`,
    method: "get",
  });
}

// 查询测试区域下的全部线路
export function selectZoneDetailInfos(zoneId, taskId) {
  let zId = "";
  let tId = "";
  if (zoneId) {
    zId = `?zoneId=${zoneId}`;
  }
  if (taskId) {
    if (zoneId) {
      tId = `&taskId=${taskId}`;
    } else {
      tId = `?taskId=${taskId}`;
    }
  }
  return request({
    url: `/test/testRealTimeMonitor/selectZoneDetailInfos${zId}${tId}`,
    method: "get",
  });
}

// 实时测试车辆列表査询
export function selectRealtimeMonitorVehicleInfos(zoneId) {
  let id = "";
  if (zoneId) {
    id = `?zoneId=${zoneId}`;
  }
  return request({
    url: `/test/testRealTimeMonitor/selectRealtimeMonitorVehicleInfos${id}`,
    method: "get",
  });
}

// 实时车辆测试详情查询

export function detailRealtimeMonitorVehicle(data) {
  return request({
    url: "/test/testRealTimeMonitor/detailRealtimeMonitorVehicle",
    method: "post",
    data: data,
  });
}
// 实时视频（提供接口）
export function getCarActualVideoInfo(frameNum, monitorDeviceId) {
  return request({
    url: `/butt/joint/getCarActualVideoInfo?frameNum=${frameNum}&monitorDeviceId=${monitorDeviceId}`,
    method: "get",
  });
}

// 模拟-版本 (实时视频)
export function getListByCondition(data) {
  return request({
    url: "/material/templateInfo/getListByCondition",
    method: "post",
    data: data,
  });
}

// 模拟-版本 -- 创建演示任务
export function copyTestTaskAndTrack(operation) {
  return request({
    url: `/test/taskInfo/copyTestTaskAndTrack?operation=${operation}`,
    method: "get",
  });
}

// 模拟-版本 -- 校验是否存在演示中任务
export function checkExistDemonstratingTask() {
  return request({
    url: `/test/taskInfo/checkExistDemonstratingTask`,
    method: "get",
  });
}

// 模拟-版本 -- 演示数据建立ws连接成功/断开连接时调用
export function operationDemonstrateTaskLocationPush(data) {
  return request({
    url: "/test/taskInfo/operationDemonstrateTaskLocationPush",
    method: "post",
    data: data,
  });
}